import type { FilterCondition } from '@crm/contracts';
import { useSession } from '../../lib/session.tsx';
import type { FilterField } from './filter-bar.tsx';
import { QuickFilters } from './quick-filters.tsx';

/**
 * A list's filters: the quick filters, or — with `filters.dsl_builder` on — the
 * condition-by-condition FilterBar in their place. Both edit the same conditions.
 */
export function FilterControls(props: {
  fields: readonly FilterField[];
  conditions: FilterCondition[];
  onChange: (next: FilterCondition[]) => void;
}) {
  const session = useSession();
  return <QuickFilters {...props} advanced={session.isEnabled('filters.dsl_builder')} />;
}
